import { useMutation } from '@tanstack/react-query';

import {
  type BulkVoucherOrderAutoAssignByOrderFiltersPayload,
  type BulkVoucherOrderAutoAssignByOrderFiltersResponse,
  bulkVoucherOrderAutoAssignByOrderFilters,
} from '~/services/PromoService';

export function useBulkVoucherOrderAutoAssignByOrderFilters() {
  return useMutation<
    BulkVoucherOrderAutoAssignByOrderFiltersResponse,
    Error,
    BulkVoucherOrderAutoAssignByOrderFiltersPayload
  >({
    mutationFn: (payload) => bulkVoucherOrderAutoAssignByOrderFilters(payload),
  });
}
